import { CardProduct } from "./CardProductComponent.style";
import { MdLibraryAdd } from "react-icons/md";
import { CardContainer } from "./CardAddProduct.style";

export default function CardAddProduct({ onClick }: { onClick: () => void }) {
  return (
    <CardProduct style={{ padding: 0 }}>
      <CardContainer onClick={onClick}>
        <h1 style={{ color: "#DDD" }}>เพิ่ม</h1>
        <MdLibraryAdd size={100} color="#DDD" />
        <h5 style={{ color: "#DDD", paddingTop: "1rem" }}>สินค้า</h5>
      </CardContainer>
    </CardProduct>
  );
}
